import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { ApiService } from 'src/app/Services/api.service';
import { LoaderService } from 'src/app/Services/loader.service';

import { CommonServices } from '../../../../../Services/common.service';
import { ExcelExportService } from '../../../../../Services/excel.service';

import { Observable } from 'rxjs';
import { StorageService } from 'src/app/Services/storage.service';
import { S3BudgetService } from 'src/app/Services/s3Budget.service';
import { table } from 'console';
import { SubjectService } from 'src/app/Services/subject-services';

@Component({
  selector: 'continuous-driving-reports',
  templateUrl: './continuous-driving-reports.component.html',
  styleUrls: ['./continuous-driving-reports.component.css'],
})
export class ContinuousDrivingComponent implements OnInit {

  public formFilters: any = FormGroup;

  public myDate = new Date();
  public maxDate: any;
  public objectKeys = Object.keys;
  public processedData: any = {};
  public excelEmpty = true;

  public enableAllOption: boolean = true;
  public multiSelectVehicle: boolean = false;
  public totalDistance: any = 0;
  public localStorage;
  constructor(
    public fb: FormBuilder,
    public comService: CommonServices,
    public api: ApiService,
    public loader: LoaderService,
    public excel: ExcelExportService,
    public storage: StorageService,
    public s2Service: S3BudgetService,
    private subject: SubjectService
  ) {
    this.maxDate = new Date(
      this.myDate.getFullYear(),
      this.myDate.getMonth(),
      this.myDate.getDate() - 1
    );
    // this.localStorage;
    this.localStorage = this.storage.get('vendorID_orgID');

    this.getRegNos();
    this.getVehicleDetails();
  }

  public vehicleRegNos: any
  public showTable: boolean;
  public vehicles: any;
  public currentDayError: boolean = false;

  public startDateError: boolean;
  public allVehDownload: boolean;
  public tableData: any = [];
  public excelData: any = {};
  public dataFound = false;

  public cols = [
    { key: '#', display: '#' },
    { key: 'date', display: 'Date' },
    {
      key: 'vegRegNo', display: 'Reg no', headerConfig: { isDefault: true },
      subKey: 'compRating',
      config: {
        isComplaint: true,  // give complaint first
        isVehicle: true
      }
    },
    { key: 'timeDuration', display: 'Movement duration (in HH:MM)', headerConfig: { isDefault: true } },
    { key: 'startToEndTime', display: 'Hours travelled duration (in HH:MM)', headerConfig: { isDefault: true } },
    { key: 'continuousDistance', display: 'Distance travelled (km)', headerConfig: { isDefault: true } },
    { key: 'continuousMaxSpeed', display: 'Maximum speed (km/h)', headerConfig: { isDefault: true } }
  ];
  public noDataFoundEnable: boolean = false;

  getVehicleDetails() {

    const obj = {
      orgID: localStorage.orgID,//this.orgID == null ? this.storage.get('vendorID_orgID').orgID : this.orgID,
      vendorID: localStorage.vendorID //this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
    };
    this.api.transportManagerVehicleList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.vehicles = res.data;
      }
    }).catch((err) => {
      console.log(err);
    });

  }

  filteredOptions: Observable<any[]>;
  selectedValues = [];

  ngOnInit(): void {
    this.storage.setData({report_submit:false});
  }

  getRegNos() {

    this.api.getOrgVehicleRegNos({}).then((res: any) => {
      if (res.status == 'success') {
        this.vehicleRegNos = res.data;
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  async getVehicleEncryptRegNo(regNo) {
     this.loader.hide();
    return new Promise((resolve, rejects) => {
      this.api.getVehicleRegNo({ vehRegNo: regNo }).then((res) => {
        if (res['status'] == 'success') resolve(res['data']);
        else rejects(res['data'])
      })
    })
  }


  async submitForm(obj: any) {
    this.dataFound = false;
    this.currentDayError = false;
     this.storage.setData({report_submit:true})
    try {
      if (obj) {
        let data_count = 0;
        let getdata_count = 0;
        let filterValues = obj.formFilds;
        this.allVehDownload = false;
        this.showTable = true;
        this.tableData = [];
        let allTrue = false;
        this.excelData = []
        this.showTable = false;
        this.noDataFoundEnable = false;
        //this.loader.show();
        const vehicle = filterValues.selectedVehicle;
        let selectedVehs
        if (obj.formFilds.selectedVehicle == 'ALL') {
          allTrue = true;
          selectedVehs = this.vehicles
            .filter(veh => veh.vehRegNo)  // Ensure vehRegNo exists
            .map(veh => veh.vehRegNo)     // Extract vehRegNo
            .sort();
          if (selectedVehs.length > 0) {
            filterValues['selectedVehs'] = selectedVehs
          }
        } else {
          filterValues['selectedVehs'] = obj.formFilds.selectedVehicle
        }
        const startDate = new Date(filterValues.sDate + '');
        // const endDate = new Date(new Date(filterValues.sDate + '').setHours(23, 59, 59)); existed code
        const endDate = new Date(filterValues.eDate + '');

        const arr: any = []
        let getDaysArray: any = function (start, end) {
          for (const dt: Date = new Date(start);
            dt <= end; dt.setDate(dt.getDate() + 1)) {
            const date = new Date(dt);
            arr.push(date.getFullYear() + '/' + pad(date.getMonth() + 1) + '/' + pad(date.getDate()));
          }
          return arr;
        };
        const pad = (num) => {
          return num > 9 ? num : '0' + num;
        };

        const start = startDate.getFullYear() + '/' + pad(startDate.getMonth() + 1) + '/' + pad(startDate.getDate());
        const end = endDate.getFullYear() + '/' + pad(endDate.getMonth() + 1) + '/' + pad(endDate.getDate());
        let daylist: any = getDaysArray(new Date(start), new Date(end));

        let vehLen = [];
        if (!Array.isArray(filterValues['selectedVehs'])) vehLen = [filterValues['selectedVehs']];
        else vehLen = filterValues['selectedVehs'];

        daylist = [...new Set(daylist)];
        const checkCurrentDay = (date) => {
          var inputDate = new Date(date).setHours(0, 0, 0, 0);


          // Get today's date
          var todaysDate = new Date().setHours(0, 0, 0, 0);
          // console.log("new Date(inputDate).getTime()",new Date(inputDate).getTime(), new Date(todaysDate).getTime())
          // call setHours to take the time out of the comparison
          if (new Date(inputDate).getTime() == new Date(todaysDate).getTime()) {
            return true;
          }
          else return false;
        };
        let vehRegArray = [];
        for (let veh = 0; veh < vehLen.length; veh++) {
          vehRegArray.push(vehLen[veh]);
        }


        let vehRegEncryKey = await this.getVehicleEncryptRegNo(vehRegArray).catch((e) => { console.log('unable to veh reg no'); })

           for (let veh = 0; veh < vehLen.length; veh++) {
           this.loader.show();
          let exlData = [];
          let pdata: any = [], excel = [];
          if (vehLen[veh] != undefined) {

            if (this.processedData[vehLen[veh]] == undefined) {
              this.processedData[vehLen[veh]] = {};
            }
            for (let day = 0; day < daylist.length; day++) {
              let checkDay = checkCurrentDay(daylist[day]);
              if (this.processedData[vehLen[veh]][daylist[day]] == undefined)
                this.processedData[vehLen[veh]][daylist[day]] = {};
              if (!checkDay) {
                //this.loader.show();

                if (vehRegEncryKey[vehLen[veh]] != null) {
                  const splitDate = daylist[day].split('/');
                  const date = splitDate[2] + splitDate[1] + splitDate[0].slice(-2);
                  const url = date + '/' + vehRegEncryKey[vehLen[veh]] + '.z';
                  const res = await this.api.readS3Data(url).catch((e) => { });
                  if (JSON.stringify(res) != '{}' && res != undefined && res != null && res != '') {
                    this.dataFound = true;
                    //this.loader.show();

                    // Await processData correctly
                    // const tempData = await this.processData(res, 10000);
                    await this.processData(res, 1000).then((tempData) => {

                      if (tempData && tempData['data']) {
                        // this.tableData = tempData['data']
                        excel = [...excel, ...tempData['xldata']];
                      }
                    }).catch((err) => {
                      console.log("error", err)
                    })

                  }

                  // else {
                  //   if (obj.formFilds.selectedVehicle == 'ALL') {

                  //     let tempData: any = {
                  //       "data": [
                  //         {
                  //           "date": "",
                  //           "dist": "",
                  //           // "vegRegNo": vehLen[veh],
                  //           "timeDuration": "No data found",
                  //           "startToEndTime": "",
                  //           "continuousDistance": "",
                  //           "continuousMaxSpeed": "",
                  //           "maxSpeed": ""
                  //         }
                  //       ],
                  //       "xldata": [
                  //         {
                  //           "value": [
                  //             "",
                  //             // vehLen[veh],
                  //             "No data found",
                  //             "",
                  //             "",
                  //             ""
                  //           ]
                  //         }
                  //       ]
                  //     }
                  //     excel = [...excel, ...tempData['xldata']];
                  //     this.tableData.push(tempData['data'])
                  //   } else {
                  //     this.showTable = false;
                  //     this.noDataFoundEnable = true;
                  //   }

                  // }
                }
                // else{
                //     if (obj.formFilds.selectedVehicle == 'ALL') {

                //       let tempData: any = {
                //         "data": [
                //           {
                //             "date": "",
                //             "dist": "",
                //             // "vegRegNo": vehLen[veh],
                //             "timeDuration": "No data found",
                //             "startToEndTime": "",
                //             "continuousDistance": "",
                //             "continuousMaxSpeed": "",
                //             "maxSpeed": ""
                //           }
                //         ],
                //         "xldata": [
                //           {
                //             "value": [
                //               "",
                //               // vehLen[veh],
                //               "No data found",
                //               "",
                //               "",
                //               ""
                //             ]
                //           }
                //         ]
                //       }
                //       excel = [...excel, ...tempData['xldata']];
                //       //this.tableData.push(tempData['data'])
                //     }

                //   }
              }
              else {


               //this.loader.show();
                let obj = {
                  vehRegNo: vehLen[veh],
                  date: new Date().setHours(0, 0, 0)
                };
                if (this.processedData[vehLen[veh]][daylist[day]] == undefined) { this.processedData[vehLen[veh]][daylist[day]] = {}; }
                let getData = await this.comService.currentDayTrackingData(obj).catch((e) => {
                  this.currentDayError = true
                });
                // let tempData: any = await this.processData(getData, 10000);
                if (getData) {
                  this.dataFound = true;
                  // getdata_count++;
                  //this.loader.show();
                  // Await processData correctly
                  // const tempData = await this.processData(res, 10000);
                  await this.processData(getData, 1000).then((tempData) => {
                    if (tempData && tempData['data']) {
                      // this.tableData = tempData['data']
                      excel = [...excel, ...tempData['xldata']];
                    }
                  }).catch((err) => {
                    console.log("error", err)
                  })
                }
                //  else {
                //     if (allTrue) {
                //       let tempData: any = {
                //         "data": [
                //           {
                //             "date": "",
                //             "dist": "",
                //             // "vegRegNo": vehLen[veh],
                //             "timeDuration": "No data found",
                //             "startToEndTime": "",
                //             "continuousDistance": "",
                //             "continuousMaxSpeed": "",
                //             "maxSpeed": ""
                //           }
                //         ],
                //         "xldata": [
                //           {
                //             "value": [
                //               "",
                //               // vehLen[veh],
                //               "No data found",
                //               "",
                //               "",
                //               ""
                //             ]
                //           }
                //         ]
                //       }

                //       excel = [...excel, ...tempData['xldata']];
                //       this.tableData.push(tempData['data'])
                //     } else {
                //       this.showTable = false;
                //       this.noDataFoundEnable = true;
                //     }

                //   }
              }
              
            }
            //if(this.dataFound){
            if (excel.length > 0) {
              data_count++;
              let rowCount = 2;
              let endCell = 'G';
              let customizedData = [];
              let titleRow = {
                value: ['Continuous Driving Report'],
                font: {
                  name: 'Cambria', family: 4, size: 16, bold: true,
                  color: { argb: 'FFFFFFFF' },

                },
                mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
                alignment: {
                  cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
                },
                fill: {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: '966462AF' },
                  bgColor: { argb: '966462AF' }
                },
              }
              customizedData.push(titleRow);
              rowCount = rowCount + 3;
              let subtitleRow = {
                value: [
                  "Vehicle            : " + String(vehLen[veh]).toUpperCase() + "\n" +
                  "Start Date       : " + this.comService.timestampToDate(new Date(startDate).getTime(), 'DMY') + "\n" +
                  "End Date         : " + this.comService.timestampToDate(new Date(endDate).getTime(), 'DMY') + ""
                ],
                font: { name: 'Cambria', family: 4, size: 12, },
                mergeCells: `A${(rowCount - 2) + ''}:${endCell + rowCount + ''}`,
              }

              customizedData.push(subtitleRow);
              rowCount = rowCount + 1;
              let headerRow =
              {
                value: (vehicle == 'ALL') ? ['S No', 'Date', 'Movement duration', 'Hours travelled duration (in HH:MM)', '	Distance travelled (km)', 'Maximum speed (km/h)'] : ['S No', 'Date', '	Reg no', '	Movement duration', 'Hours travelled duration (in HH:MM)', '	Distance travelled (km)', 'Maximum speed'],
                fill: {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'FFFFFF00' },
                  bgColor: { argb: 'FF0000FF' }
                },
                font: { bold: true },
                border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
              }
              customizedData.push(headerRow);

              let sNo = 1;
              excel = excel.map((item) => {
                item['value'] = [sNo, ...item['value']];
                if (item['value'][2] === 'No data found') {
                  item['value'][0] = '';
                } else {
                  //this.dataFound=true;
                  this.currentDayError = false;
                }
                sNo++;
                return item;
              })

              customizedData.push(...excel);

              if (this.excelData[vehLen[veh]] == undefined) { this.excelData[vehLen[veh]] = {}; }
              this.excelData[vehLen[veh]] = {
                customizedData: customizedData,
                data: {
                  columWith: [{ colNo: 1, width: 10 }, { colNo: 2, width: 20 }, { colNo: 3, width: 30 }, { colNo: 4, width: 40 }, { colNo: 5, width: 40 }, { colNo: 6, width: 30 }]
                }
              };
              //excelInfo;
            }
            //}


          }
        }

        if (vehicle != 'ALL') {
          // this.tableData.sort(function (x, y) {
          //             return x.gpsts - y.gpsts;
          //           }); 
          // console.log("!AllTabledata-----",this.tableData)
          if(this.tableData.length==0){
             this.showTable = false;
             this.noDataFoundEnable=true;

          }else{
          this.showTable = true;
          this.allVehDownload = false;
          }
            this.loader.hide(); 
            this.subject.broadcast({
              for: 'progress_handle',
              payload: true
            })
             this.storage.setData({report_submit:false})
         
        } else {
          if (this.dataFound && allTrue) {
            this.allVehDownload = true;
            this.showTable = false;
            this.tableData = [];
            this.noDataFoundEnable = false;
            
            // this.currentDayError=false;
          } else {
            this.allVehDownload = false;
            this.noDataFoundEnable = true;
            this.showTable = false;
            this.tableData = [];
          }
          this.loader.hide(); 
           this.subject.broadcast({
              for: 'progress_handle',
              payload: true
            })
             this.storage.setData({report_submit:false})
          // else{
          //   console.log("99999999999else====",this.dataFound)
          //   this.noDataFoundEnable=true;
          // }

          // if(data_count==getdata_count){
          //   this.loader.hide();

          //   this.allVehDownload = true; 
          // }else{
          //   this.allVehDownload = false; 
          //   this.tableData=[];
          // }
        }
       
        //this.noDataFoundEnable = true;
        // this.loader.hide(); 

      }
      else this.loader.hide();
      if (this.excelData && Object.keys(this.excelData).length > 0) {
        this.excelEmpty = false;
      }

    } catch (error) {
      console.log(error);
    }
  }



  processData(data: any, minInterval: any) {
    //this.loader.show();
    return new Promise((resolve, reject) => {
      try {
        //this.loader.show();
        const processedData: any[] = [];
        const excelData: any[] = [];
        let startTime: Date | null = null;
        let continuousStartTime: Date | null = null;
        let continuousEndTime: Date | null = null;
        let continuousDuration = 0; // Total continuous movement time
        let belowSpeedDuration = 0; // Time spent below speed threshold
        let totalDistance = 0;
        let continuousDistance = 0; // Track distance during continuous movement
        let threeHourThresholdMet = false;
        let maxDistance = 0;
        let maxSpeed = 0;
        let continuousMaxSpeed = 0; // Track max speed during continuous movement

        const speedThreshold = 5; // Speed threshold in km/h
        //const durationThreshold = 3  * 60 * 1000; // 3 min in milliseconds  3 * 60 * 1000;
        const durationThreshold = 3 * 60 * 60 * 1000; // 3 hours in milliseconds  3 * 60* 60 * 1000;
        const belowSpeedResetThreshold = 10 * 60 * 1000; // 10 minutes in milliseconds

        if (data && data.length > 0) {
          const sortingData: any = {};
          data.forEach((item) => {
            if (item.gpsts !== undefined) {
              item.date = this.comService.timestampToDate(item.gpsts, 'DMY H:M:S');
              sortingData[item.gpsts] = item;
            }
          });

          const objKeys = Object.keys(sortingData);
          if (objKeys && objKeys.length > 0) {
            let index = 1;

            for (let i = 0; i < objKeys.length; i++) {
              const currentKey = objKeys[i];
              const currentSpeed = parseFloat(sortingData[currentKey].spd);
              const currentTime = new Date(sortingData[currentKey].gpsts * 1000);
              let dist = 0;

              if (i > 0) {
                const previousKey = objKeys[i - 1];
                const lat1 = parseFloat(sortingData[currentKey].lat);
                const lat2 = parseFloat(sortingData[previousKey].lat);
                const lng1 = parseFloat(sortingData[currentKey].lng);
                const lng2 = parseFloat(sortingData[previousKey].lng);

                const radlat1 = Math.PI * lat1 / 180.0;
                const radlat2 = Math.PI * lat2 / 180.0;
                const theta = lng1 - lng2;
                const radtheta = Math.PI * theta / 180.0;
                let distance = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                if (distance > 1) distance = 1;
                distance = Math.acos(distance);
                distance = distance * 180 / Math.PI;
                distance = distance * 60 * 1.1515 * 1.609344; // Convert to kilometers

                dist = parseFloat(distance.toFixed(2));
                totalDistance += dist;

                if (dist > maxDistance) {
                  maxDistance = dist;
                }
              }

              // console.log(`Processing index ${i}, speed: ${currentSpeed}, distance: ${dist}`);
              //9 > 5
              if (currentSpeed > speedThreshold) {
                if (startTime === null) {
                  startTime = currentTime;
                  continuousStartTime = currentTime;
                  // console.log('Starting continuous movement tracking at:', continuousStartTime);
                } else {
                  const timeDifference = currentTime.getTime() - startTime.getTime();
                  continuousDuration += timeDifference;
                  continuousDistance += dist;
                  startTime = currentTime;
                  continuousEndTime = currentTime;
                  // console.log(`Continuous movement duration: ${continuousDuration / 1000 / 60} minutes`);
                }

                if (currentSpeed > continuousMaxSpeed) {
                  continuousMaxSpeed = currentSpeed; // Track the max speed during continuous movement
                  // console.log('Updating continuousMaxSpeed to:', continuousMaxSpeed);
                }

                belowSpeedDuration = 0; // Reset below-speed duration
                // console.log("sortingData[currentKey]", sortingData[currentKey], currentTime)
                if (continuousDuration >= durationThreshold && !threeHourThresholdMet) {
                  // console.log("3-hour continuous movement detected.", continuousStartTime);

                  const formatTime = (date: Date) => {
                    const hours = date.getHours().toString().padStart(2, '0');
                    const minutes = date.getMinutes().toString().padStart(2, '0');
                    return `${hours}:${minutes}`;
                  };

                  const startFormatted = continuousStartTime ? formatTime(continuousStartTime) : 'N/A';
                  const endFormatted = currentTime ? formatTime(currentTime) : 'N/A';

                  const startTimeParts = startFormatted.split(':');
                  const endTimeParts = endFormatted.split(':');

                  const startHours = parseInt(startTimeParts[0], 10);
                  const startMinutes = parseInt(startTimeParts[1], 10);
                  const endHours = parseInt(endTimeParts[0], 10);
                  const endMinutes = parseInt(endTimeParts[1], 10);

                  const startTimeInMinutes = startHours * 60 + startMinutes;
                  const endTimeInMinutes = endHours * 60 + endMinutes;

                  const timeDifferenceInMinutes = endTimeInMinutes - startTimeInMinutes;
                  const hours = Math.floor(timeDifferenceInMinutes / 60);
                  const minutes = timeDifferenceInMinutes % 60;

                  const timeDuration = `${hours} Hours ${minutes} Minutes`;

                  const formatDate = (date: string) => {
                    return date.split(' ')[0];
                  };

                  const result = {
                    sNo: index,
                    date: formatDate(sortingData[currentKey].date),
                    Location: String(sortingData[currentKey].near).replace('\r', ''),
                    // Distance: totalDistance.toFixed(2),
                    continuousDistance: Number(continuousDistance.toFixed(2)), // Distance during continuous movement
                    timeDuration: timeDuration,
                    startToEndTime: `${startFormatted} - ${endFormatted}`,
                    maxDistance: maxDistance.toFixed(2),
                    // vegRegNo: sortingData[currentKey].reg,
                    continuousMaxSpeed: continuousMaxSpeed, // Max speed during continuous movement
                  };

                  this.tableData.push(result);
                  excelData.push({
                    value: [
                      formatDate(sortingData[currentKey].date),
                      // sortingData[currentKey].reg,
                      timeDuration,
                      `${startFormatted} - ${endFormatted}`,
                      Number(continuousDistance.toFixed(2)),
                      // String(sortingData[currentKey].near).replace('\r', ''),
                      // sortingData[currentKey].spd,
                      continuousMaxSpeed,
                    ],
                  });
                  processedData.push({ ...result });
                  index++;

                  // Reset continuous tracking variables
                  continuousDistance = 0;
                  continuousMaxSpeed = 0;
                  maxDistance = 0;
                  threeHourThresholdMet = true;
                }
              } else {
                // Speed is below threshold
                if (startTime !== null) {
                  const timeDifference = currentTime.getTime() - startTime.getTime();
                  belowSpeedDuration += timeDifference;
                  startTime = currentTime;

                  if (belowSpeedDuration >= belowSpeedResetThreshold) {
                    continuousDuration = 0;
                    belowSpeedDuration = 0;
                    startTime = null;
                    threeHourThresholdMet = false;
                    continuousStartTime = null;
                    continuousEndTime = null;
                    continuousDistance = 0;
                    continuousMaxSpeed = 0;
                  }
                }
              }

              if (currentSpeed > maxSpeed) {
                maxSpeed = currentSpeed;
              }
            }

            if (processedData.length > 0) {
              //this.loader.hide();
              resolve({ data: processedData, xldata: excelData });
            } else {
              //this.loader.hide();
              this.showTable = false;
              //this.noDataFoundEnable = true;
              resolve({ data: [], xldata: [] });
            }
          } else {
            //this.loader.hide();
            this.showTable = false;
           // this.noDataFoundEnable = true;
            resolve({ data: [], xldata: [] });
          }
        } else {
         // this.loader.hide();
          this.showTable = false;
          //this.noDataFoundEnable = true;
          resolve({ data: [], xldata: [] });
        }
      } catch (error) {
        console.error("Error processing GPS data:", error);
        reject(error);
      }
    });

  }

  async downloadAllVehicle() {
    const chunk: any = await this.comService.chunkObject(this.excelData, 50);
    let time = new Date().getTime();
    for (let i = 0; i < chunk.length; i++) {
      this.excel.generateExcel(chunk[i], 'Continuous_Driving_Report_' + this.comService.timestampToDate(time, 'DMY', '/') + '.xlsx');
    }
  }

  // async downloadAllVehicle1() {
  //   const chunk: any = await this.comService.chunkObject(this.excelData, 50);

  //   for (let i = 0; i < chunk.length; i++) {
  //     this.excel.generateExcel(chunk[i], 'Continuous_Driving_Report_' + i + '_' + new Date().getTime() + '.xlsx');
  //   }

  // }
  downloadXL() {
    let time = new Date().getTime()
    this.excel.generateExcel(this.excelData, 'Continuous_Driving_Report_' + this.comService.timestampToDate(time, 'DMY', '/') + '.xlsx');
  }
  convertDateString(dateString) {
    const dateFormatRegex = /^\d{4}\/\d{2}\/\d{2}$/;
    if (!dateFormatRegex.test(dateString)) {
      return dateString;
    } else {
      const date = new Date(dateString);

      // Extract day, month, and year
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
      const year = date.getFullYear();

      // Return the formatted date string
      return `${day}/${month}/${year}`;
    }
  }

}
